import { apiConf as api } from 'commons'
import { useQuery, useMutation, queryCache } from 'react-query'
import { request } from '../components/sites/request'

export const downloadTemplate = (payload) => {
  return api.superFetch({ 
    url: `consommations/compteurs/export`,
    method: 'POST',
    body: payload,
   })
}

export const importConsumption = (payload) => {
    return api.superFetch({
        url: `consommations/compteurs/import`,
        method: 'POST',
        body: payload,
        contentType: null,
        stringify: false
    })
}


export const useImportConsumption = (id) => {
  return useMutation(
    (payload) =>
      request({
        url: `consommations/compteurs/import`,
        method: 'POST',
        body: payload,
        contentType: null,
        stringify: false
      }),
    {
      suspense: false,
      useErrorBoundary: false,
      throwOnError: true,
      onSuccess: () => {
        //queryCache.refetchQueries(['infos', { id }])
      },
    }
  )
}


export const useRollout = (id) => {
  return useMutation(
    (payload) =>
      request({
        url: `consommations/compteurs/rollout`,
        method: 'POST',
        body: payload,
      }),
    {
      suspense: false,
      useErrorBoundary: false,
      throwOnError: true,
      onSuccess: () => {
        //queryCache.refetchQueries(['infos', { id }])
      },
    }
  )
}


export const rollOut = (payload) => {
    return api.superFetch({
        url: `consommations/compteurs/rollout`,
        method: 'POST',
        body: payload,
    })
}
